import * as React from 'react';
import { DeviceUtilitiesService } from "../../common";
import { FlyoutDropdown, StyledCircularProgress, FlyoutArrow, FlyoutContainer } from './Flyout.style';
export class Flyout extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: props.isVisible
        };
        this.containerRef = React.createRef();
        this.flyoutRef = React.createRef();
        this.toggleFlyout = this.toggleFlyout.bind(this);
        this.setSelectedItem = this.setSelectedItem.bind(this);
        this.getDisplayValue = this.getDisplayValue.bind(this);
        this.renderFlyoutItems = this.renderFlyoutItems.bind(this);
    }
    toggleFlyout() {
        this.props.onFlyoutMenuClicked(this.props.id);
    }
    /* istanbul ignore next */
    fitFlyout() {
        let container, flyout, bottomOverflow, topMargin;
        container = this.containerRef.current.parentElement;
        flyout = this.flyoutRef.current;
        if (flyout) {
            const device = new DeviceUtilitiesService();
            bottomOverflow = this.bottomOf(flyout) - this.bottomOf(container);
            if (bottomOverflow <= 0) {
                // No overflow. No adjustment needed.
                return;
            }
            topMargin = this.topOf(flyout) - this.topOf(container);
            if (bottomOverflow < topMargin) {
                // Overflow can fit.
                if (device.isMobile()) {
                    flyout.style.marginTop = '1.625px';
                    // Overflow cannot fit. Enable scrolling.
                }
                else {
                    flyout.style.marginTop = '-' + bottomOverflow + 'px';
                }
            }
            else {
                if (device.isMobile()) {
                    flyout.style.marginTop = '1.625px';
                    // Overflow cannot fit. Enable scrolling.
                }
                else {
                    flyout.style.marginTop = '-' + topMargin + 'px';
                }
                flyout.style.maxHeight = this.outerHeightOf(container) + 'px';
            }
        }
    }
    topOf(element) {
        return element.getBoundingClientRect().top;
    }
    outerHeightOf(element) {
        let ret = element.offsetHeight;
        /* istanbul ignore next */
        if (this.props.minimumContainerHeight && ret < this.props.minimumContainerHeight) {
            ret = this.props.minimumContainerHeight;
        }
        return ret;
    }
    bottomOf(element) {
        return this.topOf(element) + this.outerHeightOf(element);
    }
    setSelectedItem(selectedFlyoutItem, selectedFlyoutIndex) {
        if (!this.props.isDisabled && selectedFlyoutItem && this.props.onFlyoutItemSelected) {
            this.props.onFlyoutItemSelected(selectedFlyoutItem, selectedFlyoutIndex);
        }
    }
    getDisplayValue(flyoutData) {
        const { propertyToDisplay, displayValueForEmpty } = this.props;
        if (flyoutData) {
            var displayValue = flyoutData;
            if (propertyToDisplay) {
                var objHierarchy = propertyToDisplay.split('.');
                for (var i = 0; i < objHierarchy.length; i++) {
                    if (!displayValue) {
                        throw `No valid display value for display property '${propertyToDisplay}' in data '${JSON.stringify(flyoutData)}'!`;
                    }
                    displayValue = displayValue[objHierarchy[i]];
                }
            }
            else {
                // default to look for 'Value' property of the object
                displayValue = displayValue.Value;
            }
            // if displayValue is empty string,
            // show miDisplayValueForEmpty instead
            return displayValue ? displayValue : displayValueForEmpty;
        }
        return '';
    }
    renderFlyoutItems() {
        let items = [];
        if (this.props.flyoutData) {
            items = this.props.flyoutData.map((data, index) => {
                return (React.createElement("li", { key: this.props.id + '_' + index, tabIndex: index, onClick: () => this.setSelectedItem(data, index) }, this.getDisplayValue(data)));
            });
        }
        return items;
    }
    componentDidUpdate() {
        this.fitFlyout();
    }
    render() {
        const { isLoading, isVisible, isDisabled, flyoutData, placeholderText, selectedFlyoutItem } = this.props;
        return (React.createElement("div", { className: this.props.className, ref: this.containerRef },
            React.createElement(FlyoutDropdown, { className: "mi-flyout mi-form-control", disabled: isDisabled, onClick: this.toggleFlyout, placeholder: placeholderText, value: this.getDisplayValue(selectedFlyoutItem), readOnly: true }),
            isLoading && React.createElement(StyledCircularProgress, { size: 20 }),
            !isLoading && !isDisabled && flyoutData && flyoutData.length > 1 && React.createElement(FlyoutArrow, null),
            isVisible && (React.createElement(FlyoutContainer, { className: "flyoutContainer" },
                React.createElement("div", { className: "selectable-item-triangle" }),
                React.createElement("ul", { ref: this.flyoutRef }, this.renderFlyoutItems())))));
    }
}
//# sourceMappingURL=Flyout.js.map